import { getValue } from 'mobx-async'
import { observer } from 'mobx-react'

import { EconFinancialHealth } from '@avantstay/arriere-clients/dist/arriereBackoffice'
import { financialHealthBadgesColors, Tooltip } from '@avantstay/backoffice-core'

import { IconGlitter } from '@avantstay/backoffice-vectors'

import { PropertyInfoStore } from '@new/domains/properties/stores/PropertyInfoStore'

import * as S from './FinancialHealthTag.styles'

const _FinancialHealthTag = ({
  color,
  hasPrefix,
  hasIcon,
}: {
  color: EconFinancialHealth
  hasPrefix?: boolean
  hasIcon?: boolean
}) => {
  const { financialHealthDescription } = PropertyInfoStore
  const isGold = color === EconFinancialHealth.gold
  const description = getValue(financialHealthDescription)

  if (!description) return null

  const descriptionMap = new Map(description.map(item => [item.color, item.description]))

  return (
    <Tooltip placement="top" content={descriptionMap.get(color)}>
      <S.StyledBadge badgeColor={financialHealthBadgesColors[color]} hasPrefix={hasPrefix}>
        {isGold ? <IconGlitter /> : null}
        {hasPrefix ? 'FH: ' : null}
        {color}
        {hasIcon ? <S.StyledInfoIcon /> : null}
      </S.StyledBadge>
    </Tooltip>
  )
}

export const FinancialHealthTag = observer(_FinancialHealthTag)
